import { z } from 'zod';

import { MatchingRecord } from '@eluve/utils';

import { PlatformTypesEnum } from './types';

export const PlatformTypesLookup = {
  WEB: 'WEB',
  EXTENSION: 'EXTENSION',
} as const satisfies MatchingRecord<PlatformTypesEnum>;

export const platformTypesSchema = z.nativeEnum(PlatformTypesLookup);
